import { ADD_PLAN } from '../actionTypes';
import { Plan, Product } from '../../services/models/product';

type PlanPayload = { plan: Plan; courses: Product };

interface Action {
  type: string;
  payload: PlanPayload;
}

const plan = (plan = {}, action: Action): PlanPayload => {
  switch (action.type) {
    case ADD_PLAN:
      return action.payload;

    default:
      return plan as any;
  }
};

export default plan;
